import styled from 'styled-components';

export const Aside = styled.aside`
  background-color: #FFF;
  width: 18%;
  min-width: 18%;
  padding-bottom: 1rem;
`;